import { useMemo } from "react";
import { useOrdreStore } from "@store/ordreStore";
import { navigateTo } from "context/navigation.service";

export default function PaiementsEnAttenteWidget() {
  const ordres = useOrdreStore((s) => s.ordres);

  const pending = useMemo(() => {
    return ordres.filter(
      (o) =>
        ((o.acompte_requested && !o.acompte_paid) || (o.solde_requested && !o.solde_paid)) &&
        o.status !== "restitue"
    ).slice(0, 8);
  }, [ordres]);

  const totalPending = useMemo(() => {
    return pending.reduce((sum, o) => sum + (o.amount || 0), 0);
  }, [pending]);

  return (
    <div className="flex flex-col bg-white border rounded-xl p-4 gap-2 shadow-lg">
      <div className="flex flex-row justify-between items-center mb-1">
        <div className="font-semibold text-black">Paiements en attente</div>
        {totalPending > 0 && (
          <span className="text-h4 font-medium rounded-full px-2 py-0.5 bg-red-50 text-red-600">
            {totalPending.toLocaleString("fr-FR")} EUR
          </span>
        )}
      </div>
      {pending.length === 0 && (
        <div className="text-h3 text-neutral-400 py-2">Aucun paiement en attente</div>
      )}
      <div className="flex flex-col divide-y">
        {pending.map((order) => {
          const waitingAcompte = order.acompte_requested && !order.acompte_paid;
          const waitingSolde = order.solde_requested && !order.solde_paid;
          return (
            <div
              key={order.id}
              className="flex flex-row items-center py-2.5 px-1 gap-3 cursor-pointer hover:bg-neutral-50 rounded-lg"
              onClick={() => navigateTo({ route: `/ordre/${order.id}` })}
            >
              <div className="flex flex-col flex-1 min-w-0">
                <div className="text-h2 font-medium text-black">{order.name}</div>
                <div className="text-h3 text-neutral-400">{order.immatriculation}</div>
              </div>
              <div className="flex flex-row gap-1 flex-shrink-0">
                {waitingAcompte && (
                  <span className="text-h4 font-medium rounded-full px-2 py-0.5 bg-amber-50 text-amber-600">
                    Acompte
                  </span>
                )}
                {waitingSolde && (
                  <span className="text-h4 font-medium rounded-full px-2 py-0.5 bg-red-50 text-red-600">
                    Solde
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
